// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { SimpleBarChart } from '@/components/composite/Charts/SimpleBarChart';

export const avgEngagementsPostTypeConfig = {
    title: 'chart.facebook.avg_engagements_post_type',
    tooltip: 'chart.facebook.tooltip_avg_engagements_post_type',
    id: 'average_engagements_per_post_type',
    noLegend: true,
    tickFormatterTranslation: 'analytics:chart.post_type_facebook',
    tableColumnFormatterTranslation: 'analytics:chart.post_type_facebook',
    margin: {
        left: -40
    },
    name: {
        type: 'chart.facebook.avg_engagements_post_type_type',
        value: 'chart.facebook.avg_engagements_post_type_value'
    },
    social: FACEBOOK,
    valueFormat: classicFormat,
    color: {
        value: 'green'
    },
    size: SIZE_50,
    type: 'chart',
    element: SimpleBarChart
};
